function pdpAccordion() {
  const accordionItems = document.querySelectorAll('.pdp-accordion-item');
  for (let i = 0; i < accordionItems.length; i++) {
    const item = accordionItems[i];
    const h3 = getChild(item, 'h3');
    const content = getChild(item, '.pdp-accordion-content');

    h3.setAttribute('role', 'button');
    h3.setAttribute('aria-expanded', 'false');
    if (content) {
      if (!content.id) content.id = 'pdp-accordion-panel-' + Math.random().toString(36).slice(2, 7);
      h3.setAttribute('aria-controls', content.id);
    }

    h3.addEventListener('click', function (e) {
      const wrapper = getParent(e.target, 'pdp-accordion');
      const clickedParent = getParent(e.target, 'pdp-accordion-item');
      const clickedTrigger = getChild(clickedParent, 'h3');
      const clickedContent = getChild(clickedParent, '.pdp-accordion-content');

      if (classHelper(clickedContent, 'c', 'active')) {
        clickedContent.style.maxHeight = '';
        classHelper(clickedContent, 'r', 'active');
        classHelper(clickedParent, 'r', 'active');
        clickedTrigger.setAttribute('aria-expanded', 'false');
        return;
      }

      // Exclusivity: close every other open item in this same accordion instance
      // (scoped by wrapper, so multiple accordions on one page don't interfere)
      // before opening the one that was just clicked.
      const otherOpenItems = wrapper ? wrapper.querySelectorAll('.pdp-accordion-item.active') : [];
      otherOpenItems.forEach(function (openItem) {
        const openContent = getChild(openItem, '.pdp-accordion-content');
        openContent.style.maxHeight = '';
        classHelper(openContent, 'r', 'active');
        classHelper(openItem, 'r', 'active');
        getChild(openItem, 'h3').setAttribute('aria-expanded', 'false');
      });

      // Exact scrollHeight (not a large fixed value) so the .3s CSS transition
      // animates across the real content height instead of mostly finishing
      // off-screen.
      clickedContent.style.maxHeight = clickedContent.scrollHeight + 'px';
      classHelper(clickedContent, 'a', 'active');
      classHelper(clickedParent, 'a', 'active');
      clickedTrigger.setAttribute('aria-expanded', 'true');
    });

    // role="button" on the h3 needs its own Enter/Space activation — browsers
    // only do this natively for real <button> elements.
    h3.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      h3.click();
    });
  }
}

function pdpInit() {
  pdpAccordion();
}

document.readyState !== 'loading' ? pdpInit() : document.addEventListener('DOMContentLoaded', pdpInit);
